import { render } from "./LinkPage.vue?vue&type=template&id=1f408c87&scoped=true"
import script from "./LinkPage.vue?vue&type=script&lang=js"
export * from "./LinkPage.vue?vue&type=script&lang=js"

import "./LinkPage.vue?vue&type=style&index=0&id=1f408c87&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f408c87"]])

export default __exports__